import { Box, debounce, Typography } from "@mui/material";
import React, { ChangeEvent, useEffect, useState } from "react";
import { Button, Heading, Input } from "../../shared/ReusableComponents";
import useGet from "../../services/hooks/useGet";
import { useDispatch } from "react-redux";
import { hideLoader, showLoader } from "../../store/currentPreferencesSlice";
import usePut from "../../services/hooks/usePut";
import { toast } from "../../store/toastSlice";
import { AlertType, DynamicPages } from "../../shared/constants/enums";
import { apiEndpoints } from "../../shared/constants/api-constant";
import { trackNotesProgress } from "../../store/userNotesSlice";

export const Adhoc = () => {
  const [adhocValue, setAdhocValue] = useState<string>("");
  const [prevAdhocValue, setPrevAdhocValue] = useState<string>("");
  const [isEnabled, setIsEnabled] = useState<boolean>(true);
  const [error, setError] = useState<boolean>(false);
  const { data: getResponse, loading: getLoading, getService } = useGet();
  const { data: putResponse, putService } = usePut();
  const dispatch = useDispatch();

  const handleSave = () => {
    if (!adhocValue.trim()) {
      setError(true);
      return;
    }
    const payload = {
      dynamicPagesId: DynamicPages.ADHOC_TOOL,
      dataJson: adhocValue,
    };

    setIsEnabled(false);
    setError(false);
    putService(apiEndpoints.DYNAMIC_PAGES, payload);
    dispatch(trackNotesProgress(false));
  };

  const handleEdit = () => {
    setIsEnabled(true);
    setError(false);
    dispatch(trackNotesProgress(true));
  };
  const handleCancel = () => {
    if (!prevAdhocValue.trim()) {
      // No initial data, just clear the field and stay in edit mode
      setAdhocValue("");
      setIsEnabled(true);
    } else {
      // Data exists, revert to previous value and disable editing
      setAdhocValue(prevAdhocValue);
      setIsEnabled(false);
    }
    setError(false);
    dispatch(trackNotesProgress(false));
  };

  useEffect(() => {
    getLoading && dispatch(showLoader());
    !getLoading && dispatch(hideLoader());
  }, [getLoading]);

  useEffect(() => {
    if (putResponse) {
      dispatch(
        toast({
          message: prevAdhocValue
            ? "Notes Successfully Updated."
            : "Notes Successfully Saved.",
          type: AlertType.SUCCESS,
        })
      );
      getService(`${apiEndpoints.DYNAMIC_PAGES}/${DynamicPages.ADHOC_TOOL}`);
    }
  }, [putResponse]);

  useEffect(() => {
    if (!getResponse) {
      getService(`${apiEndpoints.DYNAMIC_PAGES}/${DynamicPages.ADHOC_TOOL}`);
    } else {
      const trimmed = getResponse.trim();
      setPrevAdhocValue(trimmed);
      setAdhocValue(trimmed);
      // If there's data, start in view mode (disabled); otherwise editable
      setIsEnabled(!trimmed);
      setError(false);
    }
  }, [getResponse]);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setAdhocValue(e.target.value);
    if (error && e.target.value.trim()) setError(false);
    dispatch(trackNotesProgress(true));
  };

  const borderColor = error
    ? "var(--color-error-main)"
    : isEnabled
    ? "var(--color-black)"
    : "var(--color-disabled)";

  return (
    <div style={{ backgroundColor: "white", padding: "20px 0px 40px 0px" }}>
      <Box width="97%" style={{ marginLeft: "20px" }}>
        <Input
          minRows={3}
          placeholder="Add Adhoc"
          maxRows={20}
          multiline={true}
          value={adhocValue}
          onChange={handleChange}
          disabled={!isEnabled}
          style={{
            width: "100%",
            padding: "10px",
            fontSize: "1rem",
            resize: "none",
            borderRadius: "4px",
            border: "none",
            outline: "none",
            boxSizing: "border-box",
            overflow: "auto",
          }}
        />
        {error && <Typography color="error">Field is required.</Typography>}
        <Box
          sx={{
            width: "100%",
            backgroundColor: "#fff",
            display: "flex",
            justifyContent: "flex-start",
            gap: 2,
            alignItems: "center",
            mt: "20px",
            ml: "12px",
          }}
        >
          {!isEnabled && (
            <Button
              variant="contained"
              onClick={handleEdit}
              text="Edit"
              fullWidth={false}
            />
          )}
          {isEnabled && (
            <>
              <Button
                variant="outlined"
                onClick={handleCancel}
                text="Cancel"
                fullWidth={false}
              />
              <Button
                onClick={handleSave}
                text={prevAdhocValue ? "Update" : "Save"}
                fullWidth={false}
              />
            </>
          )}
        </Box>
      </Box>
    </div>
  );
};
